/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { MouseEventHandler } from 'react';
import { RiRadioButtonLine } from 'react-icons/ri';
import { IoRocketSharp } from 'react-icons/io5';

export interface Listitem {
    name: string | JSX.Element;
    icon?: any;
    className?: string;
}
export type PlanCardProps = {
    onClick?: MouseEventHandler;
    isActive?: boolean;
    isSelected?: boolean;
    className?: string;
    heading: 'developer' | 'launch' | 'build' | 'growth' | 'none';
    subHeading?: string;
    description: string;
    icon: any;
    price: {
        unit: string;
        value: string;
        period?: string;
    };
    featureList: Array<Listitem>;
    planCode: string;
    subscribe:(code:string)=>void
};

const PlanCard = ({
  onClick,
  isActive = false,
  isSelected,
  className,
  heading,
  description,
  subHeading = '',
  icon,
  price,
  featureList,
  planCode,
  subscribe,
}: PlanCardProps) => (
    <div onClick={onClick} className={`px-4 card-susbscription h-100 ${className || ''}`}>
    <div style={{ height: '85%' }}>
        <div className="col">
            {isActive && (
                <div className="active">
                    <RiRadioButtonLine />
                    {' '}
                    Active Plan
                </div>
            )}
            {isSelected && (
                <div className="selected">
                    <RiRadioButtonLine size={20} className="text-primary" />
                </div>
            )}
            {icon}
            <div className="header">
                {heading.toUpperCase()}
                <div
                    className="sub-heading fw-bold"
                    style={{
                      fontSize: 15,
                    }}
                >
            {subHeading}

                </div>
                <div className="price py-2">
                    <div>
                        {price.value !== '0' ? (
                            <>
                                <span className="unit">
                                    {price.unit}
                                    {' '}
                                </span>
                                <span className="value">{price.value}</span>
                            </>
                        )
                          : (
                                <>
                                    <span className="value">
                                        Free
                                    </span>
                                    {/* <span className="ps-1" style={{ fontSize: 14 }}> forever</span> */}
                                </>
                          )}
                          {price.period && price.value !== '0' && (
                            <span className="ps-1" style={{ fontSize: 14 }}>{price.period.toUpperCase()}</span>
                          )}
                    </div>
                    <div>
                        <p className="px-2 mt-4 text-start" style={{ fontSize: 15 }}>{description}</p>
                    </div>
                </div>
            </div>
        </div>
        <div className="feature-list col mt-auto text-start">
            {
                featureList.map((item, idx) => (
                    <p key={`iist-item${-idx}`} className={item.className}>
                        {item.icon}
                        {item.name}

                    </p>
                ))
            }
        </div>
    </div>
        <button
            type="button"
            className="container btn-success  btn mx-1 shadow my-4"
            onClick={() => { subscribe(planCode); }}
        >
            <IoRocketSharp className="mx-2" />
            Subscribe
        </button>
    </div>
);

export default PlanCard;
